import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import CustomAlert from '../../components/CustomAlert';


function Login() {
    const auth = getAuth();

    const [loading, setLoading] = useState(false);
    const [snackbarFailureOpen, setSnackbarFailure] = useState(false)
    const [snackbarSuccessOpen, setSnackbarSuccess] = useState(false)
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');



    const handleSnackbarFailClose = () => {
        setSnackbarFailure(false);
    }

    const handleSnackbarSuccessClose = () => {
        setSnackbarSuccess(false);
    }


    const signIn = async () => {
        if (email === "" && password === "") return;
        try {
            setLoading(true);

            const response = await signInWithEmailAndPassword(auth, email, password);
            if (!response.user) {
                throw ("Could Not Find User");
            }

            setSnackbarSuccess(true)
            setLoading(false);

        } catch (error) {
            console.log(error);
            
            setLoading(false);
            setSnackbarFailure(true);
        }
    }

    return (
        <div>
            <Box m={7}>
                <Typography variant="h3" style={{ fontWeight: "bolder" }}>
                    LOTUS Studio Panel
                </Typography>
            </Box>


            <Box mt={10} mb={3}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12}>
                        <TextField style={{ width: 400 }}
                            id="login_email"
                            label="Email"
                            value={email}
                            variant="outlined"
                            onChange={(val) => setEmail(val.target.value)} />
                    </Grid>
                    <Box m={1} />
                    <Grid item xs={12}>
                        <TextField style={{ width: 400 }}
                            id="login_password"
                            label="Password"
                            value={password}
                            type="password"
                            variant="outlined"
                            onChange={(val) => setPassword(val.target.value)}
                        />
                    </Grid>
                </Grid>
            </Box>

            <Button disabled={loading} variant="outlined" onClick={signIn}>
                <Typography variant='button' style={{ fontWeight: 'bold' }}>
                    LOGIN
                </Typography>
            </Button>


            <Snackbar open={snackbarFailureOpen} autoHideDuration={1000} onClose={handleSnackbarFailClose}>
                <CustomAlert severity="error">
                    Could not logged in!
                </CustomAlert>
            </Snackbar>
            <Snackbar open={snackbarSuccessOpen} autoHideDuration={1000} onClose={handleSnackbarSuccessClose}>
                <CustomAlert severity="success">
                    Logged In!
                </CustomAlert>
            </Snackbar>

        </div>
    )
}

export default Login